module.exports = __webpack_public_path__ + "img/markBGI1.7d998600.png";